/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBarberProfile200, GetApiBarberProfile400, GetApiBarberProfile401, GetApiBarberProfile403, GetApiBarberProfile404, GetApiBarberProfile500, GetApiBarberProfileQueryResponse } from "../entities/GetApiBarberProfile";
import { modelsBarberProfileOutputSchema } from "./models/barberProfileOutputSchema";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const getApiBarberProfile200Schema = z.lazy(() => modelsBarberProfileOutputSchema) as unknown as z.ZodType<GetApiBarberProfile200>

/**
 * @description Bad Request
 */
export const getApiBarberProfile400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberProfile400>

/**
 * @description Unauthorized
 */
export const getApiBarberProfile401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberProfile401>

/**
 * @description Forbidden
 */
export const getApiBarberProfile403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberProfile403>

/**
 * @description Not Found
 */
export const getApiBarberProfile404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberProfile404>

/**
 * @description Internal Server Error
 */
export const getApiBarberProfile500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberProfile500>

export const getApiBarberProfileQueryResponseSchema = z.lazy(() => getApiBarberProfile200Schema) as unknown as z.ZodType<GetApiBarberProfileQueryResponse>